import React from 'react';

/**
 * Termly CMP loads synchronously from public/index.html as the first script.
 * The banner and Auto Blocker are handled there; this component is a no-op placeholder
 * so App.tsx keeps a stable consent mount point if we add React-side hooks later.
 */
const CookieConsentBanner: React.FC = () => {
  return null;
};

CookieConsentBanner.displayName = 'CookieConsentBanner';

export default CookieConsentBanner;
